import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Input } from '@/components/atoms/Form/Input';
import { Select } from '@/components/form/Select';
import { getUseOperationZones } from '@/redux/launchDarkly/launchDarkly.slice';
import { Currency } from '@/services/innovorder/brand/brand.type';
import { AddressAutocomplete } from '@/pages/Restaurant/RestaurantInfo/components/AddressAutocomplete';
import { MapPreview } from '@/pages/Restaurant/RestaurantInfo/components/MapPreview';
import { LOCALES } from '@/pages/BrandsList/CreateBrandForm/BrandNameStep/util';
import { StepWrapper } from '../CreateRestaurantForm.style';

const currencyOptions = [
    { value: Currency.EUR, label: Currency.EUR },
    { value: Currency.GPB, label: Currency.GPB },
    { value: Currency.USD, label: Currency.USD },
];

const mappedLocales = LOCALES.map((locale) => ({ value: locale, label: locale }));

const RestaurantInfoStep = () => {
    const { control, setValue, watch } = useFormContext();
    const intl = useIntl();
    const operationZonesEnabled = useSelector(getUseOperationZones);
    const lat = watch('address.lat');
    const lng = watch('address.lng');

    return (
        <StepWrapper>
            <Controller
                name="name"
                control={control}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                        name="name"
                        labelId="brandRestaurants.create.restaurantName"
                        onChange={onChange}
                        value={value}
                        error={error?.message}
                        required
                    />
                )}
            />
            <Controller
                name="phone"
                control={control}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                        name="phone"
                        labelId="brandRestaurants.create.phone"
                        onChange={onChange}
                        value={value}
                        error={error?.message}
                        required
                    />
                )}
            />
            <Controller
                name="addressName"
                control={control}
                render={({ field: { value }, fieldState: { error } }) => (
                    <>
                        <AddressAutocomplete
                            value={value || ''}
                            required
                            onChange={(addr) => {
                                setValue('addressName', addr.name, { shouldValidate: true });
                                setValue(
                                    'address',
                                    {
                                        route: addr.route,
                                        postalCode: addr.postalCode,
                                        locality: addr.locality,
                                        country: addr.country,
                                        streetNumber: addr.streetNumber,
                                        administrativeAreaLevel1: addr.administrativeAreaLevel1,
                                        administrativeAreaLevel2: addr.administrativeAreaLevel2,
                                        provider: addr.provider,
                                        providerId: addr.providerId,
                                        lat: addr.lat,
                                        lng: addr.lng,
                                    },
                                    { shouldValidate: true },
                                );
                            }}
                        />
                        {error?.message && <span style={{ color: 'red', fontSize: '12px' }}>{error.message}</span>}
                    </>
                )}
            />
            {lat && lng ? <MapPreview lat={lat} lng={lng} /> : null}
            <Select name="locale" labelId="brandRestaurants.create.locale" options={mappedLocales} />
            {!operationZonesEnabled && (
                <Select name="currency" labelId="brandRestaurants.create.currency" options={currencyOptions} />
            )}
        </StepWrapper>
    );
};

export default RestaurantInfoStep;
